import { jsxs as e, jsx as s } from "react/jsx-runtime";
import { Button as d } from "../../shared/button/Button.component.js";
import { ButtonSizeEnum as r, ButtonThemeEnum as l } from "../../shared/button/types.js";
import { S as u } from "../../bin-icon-BRJxUkLh.js";
import * as m from "react";
import { c as a } from "../../index-C3-ZVs5E.js";
import '../../assets/FlowElementDropdown.css';const v = (o) => /* @__PURE__ */ m.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...o }, /* @__PURE__ */ m.createElement("path", { d: "M13.8434 3.63932L12.3581 2.15405C12.0427 1.83939 11.624 1.66602 11.1787 1.66602C11.178 1.66602 11.1774 1.66602 11.1768 1.66602C10.7308 1.66668 10.3121 1.84066 9.9974 2.15666L1.76139 10.4307C1.69939 10.4927 1.66406 10.5773 1.66406 10.666V13.9993C1.66406 14.1833 1.8134 14.3327 1.9974 14.3327H5.33073C5.41873 14.3327 5.50341 14.298 5.56608 14.2354L13.84 5.99935C14.1567 5.68468 14.3301 5.26599 14.3307 4.81999C14.3321 4.37399 14.1581 3.95532 13.8434 3.63932ZM5.19401 13.666H2.33138V10.804L8.49268 4.61401L11.3833 7.50472L5.19401 13.666ZM13.3708 5.52669L11.8568 7.03402L8.96338 4.14136L10.4707 2.62736C10.6594 2.43803 10.9101 2.33333 11.1781 2.33333C11.1787 2.33333 11.1794 2.33333 11.1794 2.33333C11.4467 2.33333 11.698 2.43731 11.8874 2.62598L13.3727 4.11133C13.5621 4.30066 13.6654 4.552 13.6654 4.81934C13.6654 5.08667 13.5601 5.33803 13.3708 5.52669Z", fill: "white" })), _ = "_stepId_1gvri_2", p = "_button_1gvri_12", C = "_editButton_1gvri_16", g = "_icon_1gvri_21", h = "_deleteButton_1gvri_27", B = "_divider_1gvri_32", t = {
  stepId: _,
  button: p,
  editButton: C,
  icon: g,
  deleteButton: h,
  divider: B
}, I = ({
  entityTypeId: o,
  entityTypeName: c,
  onDelete: n,
  onEdit: i
}) => /* @__PURE__ */ e("div", { children: [
  /* @__PURE__ */ e("div", { className: t.stepId, children: [
    "ID: ",
    o
  ] }),
  i && /* @__PURE__ */ e(
    d,
    {
      theme: l.naked,
      size: r.xs,
      className: a(t.button, t.editButton),
      onClick: i,
      type: "button",
      children: [
        /* @__PURE__ */ s(v, { className: t.icon }),
        " Edit ",
        c
      ]
    }
  ),
  i && n && /* @__PURE__ */ s("div", { className: t.divider }),
  n && /* @__PURE__ */ e(
    d,
    {
      theme: l.naked,
      size: r.xs,
      className: a(t.button, t.deleteButton),
      type: "button",
      onClick: n,
      children: [
        /* @__PURE__ */ s(u, { className: `${t.icon} fill-danger` }),
        " Delete",
        " ",
        c
      ]
    }
  )
] });
export {
  I as FlowElementDropdown
};
